import { Tabs } from "antd-v5";
import React, { useCallback, useMemo } from "react";
import { LogUploadSourceType } from "types/api/aiRiskMgmt";

import {
  GenericIntegrationView,
  LogFileUpload,
  TabConfig,
} from "../GenericIntegration";
import ZscalerFileUpload from "./ZscalerFileUpload";
import ZscalerS3ConfigForm from "./ZscalerS3ConfigForm";
import {
  ZSCALER_INTEGRATION_TYPE,
  ZSCALER_ZPA_INTEGRATION_TYPE,
  ZscalerS3Config,
  ZscalerZpaS3API,
  zscalerColumns,
} from "./zscalerConstants";

interface ZscalerLogsViewProps {
  onUpdateConfigComponent?: () => void;
  name?: string;
  [key: string]: unknown;
}

export default function ZscalerLogsView({
  onUpdateConfigComponent,
  name,
  ...rest
}: ZscalerLogsViewProps) {
  const s3Tabs: TabConfig[] = useMemo(
    () => [
      {
        key: "aws_s3",
        label: "ZIA S3",
        integrationType: ZSCALER_INTEGRATION_TYPE,
        customColumns: zscalerColumns,
      },
    ],
    [],
  );

  const zpaS3Tabs: TabConfig[] = useMemo(
    () => [
      {
        key: "zpa_s3",
        label: "ZPA S3",
        integrationType: ZSCALER_ZPA_INTEGRATION_TYPE,
        customColumns: zscalerColumns,
      },
    ],
    [],
  );

  const ZpaFormComponent = useCallback(
    (props: any) => (
      <ZscalerS3ConfigForm
        {...props}
        api={ZscalerZpaS3API}
        label="Zscaler ZPA"
      />
    ),
    [],
  );

  return (
    <Tabs
      defaultActiveKey="aws_s3"
      items={[
        {
          key: "aws_s3",
          label: "ZIA S3",
          children: (
            <GenericIntegrationView<ZscalerS3Config>
              tabs={s3Tabs}
              FormComponent={ZscalerS3ConfigForm}
              onUpdateConfigComponent={onUpdateConfigComponent}
              addButtonText="Add Configuration"
              name={name}
              {...rest}
            />
          ),
        },
        {
          key: "file_upload",
          label: "ZIA File Upload",
          children: <ZscalerFileUpload />,
        },
        {
          key: "zpa_s3",
          label: "ZPA S3",
          children: (
            <GenericIntegrationView<ZscalerS3Config>
              tabs={zpaS3Tabs}
              FormComponent={ZpaFormComponent}
              onUpdateConfigComponent={onUpdateConfigComponent}
              addButtonText="Add Configuration"
              name={name}
              {...rest}
            />
          ),
        },
        {
          key: "zpa_file_upload",
          label: "ZPA File Upload",
          children: (
            <LogFileUpload
              sourceType={LogUploadSourceType.ZSCALER_ZPA}
              label="Zscaler ZPA"
            />
          ),
        },
      ]}
    />
  );
}
